import React, { Component } from "react";
import GIF from "./../../assets/img/gif/done3.gif";
import GIF2 from "./../../assets/img/gif/done4.gif";

class PopUp extends Component {
  render() {
    return this.props.type === "confirm" ? (
      <div className={this.props.class}>
        {/* <div className="padding-top-20px"></div> */}
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px margin-top-30px background-white ">
            <div className="txt-site txt-12 txt-bold post-center">
              <div>
                <h2
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <i className="fa solid fa-exclamation-circle" />
                  Warning !
                  <button
                    className="btn btn-circle btn-grey"
                    onClick={this.props.onClick}
                  >
                    <i className="fa fa-lg fa-times"></i>
                  </button>
                </h2>
              </div>
            </div>
          </div>

          {/* <div
              className="image image-middle"
              style={{
                backgroundImage: 'url("' + GIF2 + '")'
              }}></div> */}

          <div className="margin-15px txt-site txt-16 txt-main txt-center txt-bold">
            Ada task yang belum selesai...
          </div>
          <div className="margin-15px txt-site txt-12 txt-primary txt-center">
            Jika disave unit akan masuk ke locator NRFS.
          </div>
          <div className="margin-15px txt-site txt-12 txt-primary txt-center">
            Yakin Teruskan?
          </div>

          <div
            className="padding-15px margin-80px"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              className="btn btn-all btn-red"
              style={{ width: "110px", marginRight: "30px" }}
              type="button"
              onClick={this.props.onClick}
            >
              <span>CANCEL</span>
            </button>
            <button
              className="btn btn-all btn-green"
              type="button"
              style={{ width: "110px" }}
              onClick={this.props.onClick}
            >
              <span>OK</span>
            </button>
          </div>
          <div className="padding-10px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "clear" ? (
      <div className={this.props.class}>
        {/* <div className="padding-top-10px"></div> */}
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px margin-top-30px background-white ">
            <div className="txt-site txt-12 txt-bold post-center">
              <div>
                <h2
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <i className="fa solid fa-exclamation-circle" />
                  Warning !
                  <button
                    className="btn btn-circle btn-grey"
                    onClick={this.props.onClick}
                  >
                    <i className="fa fa-lg fa-times"></i>
                  </button>
                </h2>
              </div>
            </div>
          </div>

          {/* <div
              className="image image-middle"
              style={{
                backgroundImage: 'url("' + GIF2 + '")'
              }}></div> */}

          <div className="margin-5px txt-site txt-16 txt-main txt-center txt-bold">
            Data akan di hapus secara permanen dan tidak dapat dikembalikan.
          </div>
          <div className="margin-15px txt-site txt-12 txt-primary txt-center">
            Jika disave unit akan masuk ke locator NRFS.
          </div>
          <div className="margin-15px txt-site txt-12 txt-primary txt-center">
            Yakin Teruskan?
          </div>

          <div
            className="padding-15px margin-80px"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <button
              className="btn btn-all btn-red"
              style={{ width: "110px", marginRight: "30px" }}
              type="button"
              onClick={this.props.onClick}
            >
              <span>CANCEL</span>
            </button>
            <button
              className="btn btn-all btn-green"
              type="button"
              style={{ width: "110px" }}
              onClick={this.props.onClick}
            >
              <span>OK</span>
            </button>
          </div>
          <div className="padding-10px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "doneSave" ? (
      <div className={this.props.class}>
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px background-white grid grid-2x">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold post-center">
                <div>Perhatian</div>
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div
            className="image image-middle"
            style={{
              backgroundImage: 'url("' + GIF + '")',
            }}
          ></div>

          <div className="margin-15px txt-site txt-16 txt-main txt-center txt-bold">
            {this.props.infoSub
              ? this.props.infoSub
              : "Data saved successfully..."}
          </div>
          {this.props.infoSubMessage && (
            <div className="margin-15px txt-site txt-16 txt-main txt-center">
              {this.props.infoSubMessage}
            </div>
          )}

          <div className="padding-15px" style={{ textAlign: "center" }}>
            <button
              className="btn btn-all btn-green btn-width-all"
              type="button"
              onClick={this.props.onClick}
            >
              <span>OK</span>
            </button>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "save" ? (
      <div className={this.props.class}>
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px background-white grid grid-2x">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold post-center">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>

          {/*<div style={{textAlign: 'center', marginTop:10, color:'green', fontSize:44}}>
                <i className="fa fa-lw fa-check-circle"/>
              </div>*/}

          <div
            className="image image-middle"
            style={{
              backgroundImage: 'url("' + GIF + '")',
            }}
          ></div>

          <div className="margin-15px txt-site txt-16 txt-main txt-center txt-bold">
            Data Saved Successfully
          </div>

          <div className="padding-15px" style={{ textAlign: "center" }}>
            <button
              className="btn btn-all btn-green btn-width-all"
              type="button"
              onClick={this.props.onClick}
            >
              <span>OK</span>
            </button>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "processSaving" ? (
      <div className={this.props.class}>
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px background-white grid grid-2x">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold post-center">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>

          {/*<div style={{textAlign: 'center', marginTop:10, color:'green', fontSize:44}}>
              <i className="fa fa-lw fa-check-circle"/>
            </div>*/}

          <div
            className="image image-middle"
            style={{
              backgroundImage: 'url("' + GIF + '")',
            }}
          ></div>

          <div className="margin-15px txt-site txt-16 txt-main txt-center txt-bold">
            {this.props.messageCustom}
          </div>

          <div className="padding-15px" style={{ textAlign: "center" }}>
            <button
              className="btn btn-all btn-green btn-width-all"
              type="button"
              onClick={this.props.onClick}
            >
              <span>OK, GOT IT!</span>
            </button>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "delete" ? (
      <div className={this.props.class}>
        <div
          className="popup-alert border-radius"
          style={{ backgroundColor: "white" }}
        >
          <div className="grid grid-2x padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-white post-top">
                {/* Danger */}
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle"
                style={{ backgroundColor: "white", color: "#F73E3E" }}
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div className="txt-site txt-big txt-red txt-center margin-30px">
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px txt-site txt-16 txt-black txt-center txt-bold">
            Are you sure?
          </div>
          <div className="margin-20px txt-site txt-10 txt-black txt-center">
            Do you really want to delete these records ?
            <div />
            this process cannot be undone.
          </div>
          {/* <div className="txt-site txt-10 txt-black txt-center">
                  this process cannot be undone.
                </div> */}
          <div
            className="padding-15px grid grid-2x"
            style={{ alignContent: "center" }}
          >
            <div className="col-1">
              <button
                disabled={this.props.isLoading}
                className="btn padding-5px"
                type="button"
                onClick={this.props.onClickDelete}
              >
                <span>{!this.props.isLoading ? "YES" : "Processing..."}</span>
              </button>
            </div>
            <div className="col-2">
              <button
                className="btn padding-5px"
                type="button"
                style={{ color: "#eee", backgroundColor: "#F73E3E" }}
                onClick={this.props.onClick}
              >
                <span>CANCEL</span>
              </button>
            </div>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "simpanWorkshift" ? (
      <div className={this.props.class}>
        <div
          className="popup-alert border-radius"
          style={{ backgroundColor: "white" }}
        >
          <div className="grid grid-2x padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-white post-top">
                {/* Danger */}
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle"
                style={{ backgroundColor: "white", color: "#F73E3E" }}
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div className="txt-site txt-big txt-red txt-center margin-30px">
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px txt-site txt-16 txt-black txt-center txt-bold">
            Are you sure?
          </div>
          <div className="margin-20px txt-site txt-10 txt-black txt-center">
            Data yang diubah akan mengupdate waktu masuk dan waktu pulang
            absensi hari ini
            <div />
            Apakah Anda yakin untuk merubah data ?
          </div>

          <div
            className="padding-15px grid grid-2x"
            style={{ alignContent: "center" }}
          >
            <div className="col-1">
              <button
                disabled={this.props.isLoading}
                className="btn padding-5px"
                type="button"
                onClick={this.props.onClickDelete}
              >
                <span>{!this.props.isLoading ? "YES" : "Processing..."}</span>
              </button>
            </div>
            <div className="col-2">
              <button
                className="btn padding-5px"
                type="button"
                style={{ color: "#eee", backgroundColor: "#F73E3E" }}
                onClick={this.props.onClick}
              >
                <span>CANCEL</span>
              </button>
            </div>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "simpan" ? (
      <div className={this.props.class}>
        <div className="popup-alert border-radius background-white">
          <div className="grid grid-2x background-white padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-black post-top">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
                disabled={this.props.disabled}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div className="txt-site txt-big txt-green txt-center margin-30px">
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px padding-10px txt-site txt-16 txt-black txt-center txt-bold">
            {this.props.infoSub ? this.props.infoSub : "Process this data?"}
          </div>
          <div
            className="padding-15px grid grid-2x"
            style={{ alignContent: "center" }}
          >
            <div className="col-1">
              <button
                className="btn padding-5px"
                type="button"
                disabled={this.props.disabled}
                onClick={this.props.onClickSimpan}
              >
                <span>{this.props.disabled ? "Saving..." : "YES"}</span>
              </button>
            </div>
            <div className="col-2">
              <button
                className="btn btn-all btn-green btn-width-all padding-5px"
                type="button"
                disabled={this.props.disabled}
                // style={{color:'#eee', backgroundColor:'green'}}
                onClick={this.props.onClick}
              >
                <span>CANCEL</span>
              </button>
            </div>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "inprogress" ? (
      <div className={this.props.class}>
        <div className="popup-alert border-radius background-white">
          <div className="grid grid-2x background-white padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-black post-top">
                {this.props.title ? this.props.title : "Information"}
              </div>
            </div>
            <div className="col-2 content-right">
              <button className="btn btn-circle btn-grey" disabled={true}>
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div className="txt-site txt-big txt-green txt-center margin-30px">
            <i className="fa fa-2x fa-cog fa-spin" />
          </div>
          <div className="margin-15px padding-10px txt-site txt-16 txt-black txt-center txt-bold">
            {this.props.subTitle ? this.props.subTitle : "Processing..."}
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "alert" ? (
      <div className={this.props.class}>
        <div className="popup-alert background-white border-radius">
          <div className="padding-15px background-white grid grid-2x">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold post-center">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div
            className="margin-15px txt-site txt-main txt-center txt-bold"
            style={{ fontSize: "30px", color: "gray" }}
          >
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px padding-10px txt-site txt-16 txt-main txt-center txt-bold">
            {this.props.alertInfo.includes("REJECTED") ||
            this.props.alertInfo.includes("APPROVED") ? (
              <span>
                {"Your loan proposal is "}
                <span
                  style={{
                    fontWeight: "bold",
                    color: this.props.alertInfo.includes("APPROVED")
                      ? "green"
                      : "red",
                  }}
                >
                  {this.props.alertInfo.split("Your loan proposal is ")[1]}
                </span>
              </span>
            ) : (
              this.props.alertInfo
            )}
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "customAlert" ? (
      <div className={this.props.class}>
        <div
          className="popup-alert border-radius background-white"
          style={{ width: this.props.width }}
        >
          <div className="grid grid-2x background-white padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-black post-top">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div className="txt-site txt-big txt-red txt-center margin-30px">
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px txt-site txt-16 txt-black txt-center txt-bold">
            {this.props.infoSub}
          </div>
          <div className="margin-15px txt-site txt-12 txt-black txt-center">
            {this.props.infoSubMessage}
          </div>
          <div
            className="padding-15px grid grid-2x"
            style={{ alignContent: "center" }}
          >
            <div className="col-1">
              <button
                className="btn padding-5px"
                type="button"
                onClick={this.props.onClickYes}
              >
                <span>{this.props.yes}</span>
              </button>
            </div>
            <div className="col-2">
              <button
                className="btn btn-all btn-red btn-width-all padding-5px"
                type="button"
                // style={{color:'#eee', backgroundColor:'green'}}
                onClick={this.props.onClickNo}
              >
                <span>{this.props.no}</span>
              </button>
            </div>
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : this.props.type === "information" ? (
      <div className={this.props.class}>
        <div
          className="popup-alert border-radius background-white"
          style={{ width: this.props.width }}
        >
          <div className="grid grid-2x background-white padding-15px">
            <div className="col-1">
              <div className="txt-site txt-12 txt-bold txt-grey post-top">
                Information
              </div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>
          <div
            className="txt-site txt-big txt-grey txt-center margin-30px"
            style={{ color: "gray" }}
          >
            <i className="fa fa-2x fa-info-circle" />
          </div>
          <div className="margin-15px txt-site txt-16 txt-grey txt-center txt-bold">
            {this.props.infoSub}
          </div>
          <div className="margin-15px txt-site txt-12 txt-grey txt-center">
            {this.props.infoSubMessage}
          </div>
          <div className="padding-bottom-15px"></div>
        </div>
        <div className="padding-bottom-20px"></div>
      </div>
    ) : (
      <div className={this.props.class}>
        <div className="popup-content-mikro background-white border-radius post-center">
          <div className="popup-panel grid grid-2x">
            <div className="col-1" style={{ width: "140%" }}>
              <div className="popup-title">{this.props.title}</div>
            </div>
            <div className="col-2 content-right">
              <button
                className="btn btn-circle btn-grey"
                onClick={this.props.onClick}
              >
                <i className="fa fa-lg fa-times"></i>
              </button>
            </div>
          </div>

          <div className="padding-15px background-grey">
            <input
              type="file"
              id="upload-image"
              style={{ display: "none" }}
              onChange={this.props.onChange}
            />

            <input
              type="file"
              id="upload-image"
              style={{ display: "none" }}
              onChange={this.props.onChange}
            />

            <div className="upload-image">
              <div className="u-i-info">
                <div className="u-i-icon">
                  <i className="fa fa-lg fa-images" />
                </div>
                <div className="u-i-label">Upload a file</div>
              </div>

              <div
                className="u-i-image image image-all"
                style={{ backgroundImage: "url(" + this.props.file + ")" }}
              >
                <div className="u-i-btn">
                  <label htmlFor="upload-image">
                    <div className="btn btn-circle-div btn-green border-all">
                      <i className="fa fa-lg fa-plus" />
                    </div>
                  </label>
                  <button
                    onClick={this.props.removeChange}
                    type="button"
                    className="btn btn-circle btn-red border-all"
                  >
                    <i className="fa fa-lg fa-trash-alt" />
                  </button>
                </div>
              </div>
            </div>

            <div className="grid margin-top-15px">
              <div className="content-right">
                <button
                  className="btn btn-primary"
                  onClick={this.props.onClick}
                >
                  CLOSE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PopUp;
